<template>
  <div>
    <pre class="select-none bg-gray-300 rounded-lg p-5 overflow-x-scroll">{{
      parseJson(value)
    }}</pre>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true,
    },
  },
  methods: {
    parseJson(value) {
      let str = JSON.stringify(value, this.getCircularReplacer());
      let lines = str.split(/\n/);
      let wrapped = "[" + lines.join(",") + "]";
      let obj = JSON.parse(wrapped);
      return obj;
    },

    getCircularReplacer() {
      const seen = new WeakSet();
      return (key, value) => {
        if (key != "ctx" && key != "buffer") {
          if (typeof value === "object" && value !== null) {
            if (seen.has(value)) {
              return;
            }
            seen.add(value);
          }
          return value;
        } else {
          return "ctxObj";
        }
      };
    },
  },
};
</script>
<style scoped>
</style>
